<div *ngIf="searchEntries" class="page-container">
  <app-cards [cards]="searchEntries" [page]="null"></app-cards>
</div>

<div *ngIf="!searchEntries || isLoading" class="page-container page">
  <h2>Vennligst vent på at søket er ferdig</h2>
</div>
